import UsersContentItem from '../../components/UsersContentItem/UsersContentItem';
import './UsersContent.css';
import NewUser from '../../components/NewUser/NewUser';

import { getAllUsers, updateAccountStatus, deleteUser } from '../../utilities/api/users'
import { useEffect, useState } from 'react';

export default function UsersContent({ user, toggleNotifications }) {
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState([])
  
  const deleteUserItem = async (userItem) => {
      try {
        await deleteUser(userItem)
        const allUsers = await getAllUsers()
        setUsers(allUsers)
        await toggleNotifications('success', 'User deleted successfully', '#E21D12')
      } catch (error) {
        await toggleNotifications('error', 'Failed to delete user', '#FFFFFF')
        console.log(error)
      }
  }

  const updateUsers = async () => {
    setLoading(true)
    try {
      const allUsers = await getAllUsers()
      setUsers(allUsers)
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }

  const updateUserStatus = async (data) => {
    try {
      await updateAccountStatus(data)
      const allUsers = await getAllUsers()
      setUsers(allUsers)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (user.userType === 'admin' || user.userType === 'manager') {
      updateUsers()
    }
    // eslint-disable-next-line
  },[])

  return (
    <div className='UsersContent'>
      <div className='usersHeadingContainer'>
        <div className='section1'>
            Users
        </div>
        <div className='section2'>
            { user.userType === 'admin' &&
            <>
            <button className='createUser' data-bs-toggle="modal" data-bs-target={`#newUserModal`}>
                <svg width="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="38" height="38" rx="10" fill="#FFFFFF" opacity='0.2'/>
                    <path d="M19 11V27V11ZM27 19H11H27Z" fill="#2173F0"/>
                    <path d="M19 11V27M27 19H11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>
                &nbsp;&nbsp;&nbsp;New User
                </span>
            </button>
            <NewUser user={user} updateUsers={updateUsers} toggleNotifications={toggleNotifications} />
            </>
            }
        </div>
      </div> 
      {loading ?
      <div className='loading'>
        <div className="spinner-border" role="status"></div>
      </div>
      :
      <div className='usersMainSection'>
      { users && users.length>0 ?
          users.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1).map((userItem, idx) => (
              <UsersContentItem currentUser={user} userItem={userItem} idx={idx} key={idx} deleteUserItem={deleteUserItem} updateUserStatus={updateUserStatus} />
          ))
          : 
          <h5 className='text-center'><strong>No Users</strong></h5>
      }
      </div>
      }
    </div>
  )
}
